import type { ForYouConfig } from '@atlassian/global-side-navigation';

export function getForYouConfig(): ForYouConfig {
	return {
		hideForYou: true,
		hideRecents: true,
		hideStarred: true,
	};
}
